<template>
    <div class="col-12 mb-primary">
        <div class="card card-with-shadow border-0 h-100">
            <div class="card-header p-primary bg-transparent">
                <h5 class="card-title m-0">{{ $t('office_add') }}</h5>
            </div>
            <app-overlay-loader v-if="preloader"/>
            <div class="card-body">
                <form ref="form" data-url="/office/store" class="mb-0" :class="{'loading-opacity': preloader}" enctype="multipart">
                    
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('name') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="reqData.name"
                                   :required="true"
                                   :placeholder="$t('name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label for="email_input" class="col-sm-2 mb-sm-0">
                            {{ $t('email') }}
                        </label>
                        <app-input id="email_input"
                                   class="col-sm-8"
                                   v-model="reqData.email"
                                   type="email"
                                   :placeholder="$t('email_type_input')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label for="number_input" class="col-sm-2 mb-sm-0">
                            {{ $t('mobile_no') }}
                        </label>
                        <app-input id="number_input"
                                   class="col-sm-8"
                                   type="text"
                                   v-model="reqData.mobile_no"
                                   :placeholder="$t('number_type_input')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label for="number_input" class="col-sm-2 mb-sm-0">
                            {{ $t('order_on') }}
                        </label>
                        <app-input id="number_input"
                                   class="col-sm-8"
                                   type="number"
                                   v-model="reqData.order_on"
                                   :placeholder="$t('number_type_input')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('address') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="reqData.address"
                                   :required="false"
                                   :placeholder="$t('address_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('address1') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="reqData.address1"
                                   :required="false"
                                   :placeholder="$t('address_name')"/>
                    </div>
                    <div class="form-group row">
                        <label for="inputs_editor" class="col-sm-2 h-fit-content">
                            {{ $t('content') }}
                        </label>
                        <div class="col-sm-8">
                            <app-input type="text-editor"
                                       :required="false"
                                       id="text-editor-id"
                                       :label="$t('message_placeholder')" v-model="reqData.description"/>
                        </div>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('meta_keyword') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="reqData.meta_keyword"
                                   :required="false"
                                   :placeholder="$t('meta_key_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('meta_title') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="text"
                                   v-model="reqData.meta_title"
                                   :required="false"
                                   :placeholder="$t('meta_title_name')"/>
                    </div>
                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('meta_description') }}
                        </label>
                        <app-input class="col-md-8"
                                   type="textarea"
                                   v-model="reqData.meta_description"
                                   :required="false"
                                   :placeholder="$t('meta_description_name')"/>
                    </div>                    
                    
                    <div class="form-group row mb-0">
                        <label class="col-sm-2 mb-sm-0">
                            {{ $t('upload_image') }}
                        </label>
                        <div class="col-sm-8">
                            <app-input type="custom-file-upload"
                                       :label="$t('upload_your_file')"
                                       v-model="reqData.featured_image"/>
                        </div>
                    </div>

                    <div class="form-group row align-items-center">
                        <label class="col-md-2 mb-md-0">
                            {{ $t('status') }}
                        </label>
                            <app-input class="col-md-8 mt-2 pt-1"
                                       type="radio"
                                       :list="statusLists"
                                       v-model="reqData.status"
                                       :required="true"/>
                    </div>
                    <div class="mt-5 action-buttons">
                        <button type="submit" class="btn btn-primary mr-2" @click.prevent="submit">
                            {{ $t('submit')}}
                        </button>
                        <button type="submit" class="btn btn-secondary" @click.prevent="clear">
                            {{ $t('clear') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import {FormMixin} from "../../../../../core/mixins/form/FormMixin"; 
    export default {
        name: "FormLayouts",
        mixins: [FormMixin],
        props: ['categories'],
        data() {
             return {
                preloader: false,
                reqData: {
                    name: '',
                    email: '',
                    mobile_no: '',
                    address: '',
                    address1: '',
                    description: '',
                    meta_keyword: '',
                    meta_title: '',
                    meta_description: '',
                    featured_image: '',
                    status: 'active',
                    order_on: '999',

                },
                statusLists: [
                    {id: 'active', value: "Active"},
                    {id: 'inactive', value: "Inactive"},
                ]
            }
        },
        methods: {
            beforeSubmit(){
                this.preloader = true;
            },
            submit() {
                let formData = new FormData;
                for (const [key, value] of Object.entries(this.reqData)) {
                    if (value != null) formData.append(key, value);
                }
                this.save(formData);
            },
            afterSuccess(res) {
                this.$toastr.s(res.data.message);
            },
            afterFinalResponse() {
                this.preloader = false;
                this.reqData = {
                    status: 'active',
                    order_on: '999'
                };
            },
            afterError(res) {
                this.$toastr.e(res.data.message);
            },
            clear() {
                this.reqData = {
                    status: 'active',
                    order_on: '999'
                };
                this.fieldStatus = {
                    isSubmit: false
                }
            },
        }

    }
</script>
